// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".shared-step-editor-header-name[data-v-761cfaca]{display:flex;gap:10px;line-height:16px;align-items:center;margin-left:20px;color:#fff}.shared-step-editor-header-name__icon[data-v-761cfaca]{width:18px}", ""]);
// Exports
module.exports = exports;
